import { Model } from "@interfaces/model.interface";

export interface Supplier extends Model {
	address1: string;
	address2: string;
	approvedSupplier: boolean;
	excludeFromRFQs: boolean;
	name: string;
	paymentTermId: number;
	postcode: string;
	questionnaireCompleted: boolean;
	rfqContactId?: number;
	telephoneNumber: string;
	town: string;
}

export class Supplier implements Supplier {
	address1 = "";
	address2 = "";
	approvedSupplier = false;
	name = "";
	postcode = "";
	questionnaireCompleted = false;
	telephoneNumber = "";
	town = "";

	constructor(data?: Partial<Supplier>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}